export const MAP_STYLE = `https://maps.geo.us-east-1.amazonaws.com/v2/styles/Standard/descriptor?key=${process.env.REACT_APP_AWS_API_KEY}&color-scheme=Light`;
